import { hasTaskId, makeIntegration } from '@ci/control-flow';
import { both } from 'ramda';
import { getIsAnyErrorResponseAction, getIsAnySuccessResponseAction } from '../utils';

export const controlFlowIntegrationMiddleware = makeIntegration(
	both(getIsAnySuccessResponseAction, hasTaskId),
	both(getIsAnyErrorResponseAction, hasTaskId)
);
